export default function Photo ({photo}) {
    return (
        <img src={photo} alt="google-img" />
    )
}